import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { useTenantContext } from "../../tenant/TenantContext";

/**
 * Aviso para productos bajo pedido con bypass de stock (details.stockBypass):
 * se pueden pedir aunque no haya unidades y la fecha estimada de entrega se
 * consulta por teléfono. El teléfono sale de la config del tenant (cada marca
 * enseña el suyo).
 */
export const StockBypassNotice = ({ product, className = "" }) => {
    const { tel } = useTenantContext();
    if (!product?.stockBypass) {
        return null;
    }
    return (
        <div className={`alert alert-info d-flex align-items-center gap-2 py-2 ${className}`} role="status">
            <PhoneInTalkIcon fontSize="small" />
            <span>
                Producto bajo pedido: puedes pedirlo aunque no haya stock. Si quieres saber la fecha
                estimada de entrega, llámanos{tel ? <> al <a href={`tel:${tel}`} className="fw-bold text-nowrap">{tel}</a></> : null}.
            </span>
        </div>
    );
};
